export const apiURL="https://icaigbnapi.proeffico.com/api/";
export const imageURL="https://icaigbnapi.proeffico.com/";
export const otpServiceV2Url="https://otp.proeffico.com/api/v2.0/"
